<template>
  <section class="">
    <div class="grid-layout columns is-variable is-3 is-multiline">
      <template v-if="state.loading">
        <div class="column is-one-third" v-for="i in 12" :key="i">
          <result-skeleton />
        </div>
      </template>
      <template v-else-if="state.instances.length">
        <div
          class="column is-one-third"
          v-for="instance in state.instances"
          :key="instance.id"
        >
          <result-card :instance="instance" />
        </div>
      </template>
      <template v-else>
        <div class="column full">
          <div class="content has-text-centered">
            <h1 class="title">No se encontraron resultados</h1>
            <p>
              Puede <a href="/presentes">volver atrás</a> y realizar
              una nueva búsqueda
            </p>
          </div>
        </div>
      </template>
    </div>
    <paginator v-if="!state.loading" />
  </section>
</template>
<script>
import ResultCard from "./ResultCard.vue";
import ResultSkeleton from "./ResultSkeleton.vue";
import Paginator from "./Paginator.vue";
import store from "../store";

export default {
  components: { ResultCard, ResultSkeleton, ResultCard, Paginator },
  data() {
    return {
      state: store.state,
    };
  },
};
</script>
